<template>

  <Modal
    width="800"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      :style="
      {
        width: '700px !important'
      }
      "
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="画展标题">
        <Input
          class="c-form__input"
          :value="artshowTitle"
          disabled
        />
      </Form-item>
      <Form-item label="艺术家">
        <Input
          class="c-form__input"
          :value="artistName"
          disabled
        />
      </Form-item>
      <Form-item label="作品">
        <Input
          class="c-form__input"
          :value="artsTitle"
          disabled
        />
      </Form-item>

      <Form-item label="链接" prop="link">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.link"
        />
      </Form-item>

       <Form-item label="内容" prop="content">
        <c-editor
          :html="cForm.model.content"
          @change="
            html => {
              $set(cForm.model, 'content', html);
              $refs.form.validateField('content');
            }
          "
        ></c-editor>
      </Form-item>
      
      
      <Form-item label="状态" prop="status">
        <Select
          class="c-form__input"
          placeholder="请选择状态"
          clearable
          v-model="cForm.model.status"
        >
          <Option
            v-for="item in dicts.PublishStatus"
            :key="item.value"
            :value="item.value"
            :label="item.label"
            >{{ item.label }}
          </Option>
        </Select>
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "artshowitem";

@Component({
  mixins: [FormMixin],
  computed: {
      artsTitle() {
        return this.cForm.model.arts && this.cForm.model.arts.title;
      },
      artshowTitle() {
        return this.cForm.model.artshow && this.cForm.model.artshow.title;
      },
      artistName() {
        return this.cForm.model.artist && this.cForm.model.artist.name;
      }
  }
})
export default class BrandsListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          
        }
      }
    };
  }

  getFormInitModel() {
    return {
      status: 1
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;

        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );
        this.$emit("get-list", data);
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.cForm.modal = false;
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
